import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenProceduresIndicatorB6 } from "@/services/esus/indicator/esb/b6/getDetailedCitizenProceduresIndicatorB6";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsbB6DentalAttendanceProceduresHistoryItem } from "./IndicatorEsbB6DentalProcedureHistoryItem";
import { IndicatorEsbB6CitizenHistoryInfo } from "./IndicatorEsbB6CitizenHistoryInfo";
import { timeDimensionToString } from "@/utils/dateUtil";

type IndicatorEsbB6CitizenAttendancesHistoryProps = {
	citizenWithDentalAttendanceProcedures: DetailedCitizenProceduresIndicatorB6;
};

export function IndicatorEsbB6CitizenAttendancesHistory({
	citizenWithDentalAttendanceProcedures,
}: Readonly<IndicatorEsbB6CitizenAttendancesHistoryProps>) {
	const indicatorEsbB6CitizenHistoryInfo = {
		fullName: citizenWithDentalAttendanceProcedures.fullName
			? citizenWithDentalAttendanceProcedures.fullName
			: "N/A",
		birthdate: citizenWithDentalAttendanceProcedures.birthdate
			? dayjs(citizenWithDentalAttendanceProcedures.birthdate).format("DD/MM/YYYY")
			: "N/A",
		document: citizenWithDentalAttendanceProcedures.cpf
			? formatIdentifier(citizenWithDentalAttendanceProcedures.cpf)
			: citizenWithDentalAttendanceProcedures.cns ?? "",
		motherName: citizenWithDentalAttendanceProcedures.motherName ?? "",
		phone: citizenWithDentalAttendanceProcedures.phone
			? phoneFormat(citizenWithDentalAttendanceProcedures.phone)
			: "",
		address:
			addressConcat(
				citizenWithDentalAttendanceProcedures.street,
				citizenWithDentalAttendanceProcedures.houseNumber,
				citizenWithDentalAttendanceProcedures.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsbB6CitizenHistoryInfo {...indicatorEsbB6CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Procedimentos Odontológicos"
				timeLineContents={(
					citizenWithDentalAttendanceProcedures.dentalAttendanceProcedures ?? []
				).map<TimeLineContent>((dentalAttendanceProcedure) => {
					return {
						content: (
							<IndicatorEsbB6DentalAttendanceProceduresHistoryItem
								dentalAttendanceProcedure={dentalAttendanceProcedure}
							/>
						),
						eventDate:
							timeDimensionToString(dentalAttendanceProcedure.timeDimensionId) ||
							"N/A",
					};
				})}
			/>
		</>
	);
}
